/**
 * `(33) 98765-4321`. O número chega só com dígitos (normalizado na gravação,
 * migração 0006); o que não tem cara de telefone brasileiro sai como veio.
 *
 * Usado pela coluna de Clientes e pela exportação (F131) — a planilha mostra o
 * telefone como a tela.
 */
export const formatPhone = (digits) => {
    const local = digits.startsWith('55') && digits.length > 11 ? digits.slice(2) : digits;
    if (local.length === 11) {
        return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
    }
    if (local.length === 10) {
        return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
    }
    return digits;
};
//# sourceMappingURL=phone-format.js.map